import { useEffect } from 'react'
import { Toast as ToastDS } from '@iveco-ti/iveco-ds'
import { AlertOctagon, LoaderCircle } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router'
import { toast } from 'react-toastify'

import { Toast } from '@/common/components/Toast'
import { useSignIn } from '../../hooks/useSignIn'
import SignIn from '../SignIn'

export default function Sso() {
  const [searchParams] = useSearchParams()
  const { t } = useTranslation('login')
  const { identifyUser } = useSignIn()

  useEffect(() => {
    const token = searchParams.get('token')

    if (!token) return

    const id = toast(
      <ToastDS.Root color="info" soft>
        <ToastDS.Icon icon={<LoaderCircle className="animate-spin" />} />
        <ToastDS.Body>
          <ToastDS.Title title={t('sso.toast_info.title')} />
          <ToastDS.Description description={t('sso.toast_info.description')} />
        </ToastDS.Body>
      </ToastDS.Root>,
      { autoClose: false },
    )

    identifyUser(token, false)
      .catch(() => {
        toast(Toast, {
          data: {
            type: 'danger',
            icon: AlertOctagon,
            title: t('sso.toast_error.title'),
            description: t('sso.toast_error.description'),
          },
        })
      })
      .finally(() => toast.dismiss(id))
  }, [searchParams, t, identifyUser])

  return <SignIn />
}
